import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "confirm-meeting-container loading" }
const _hoisted_2 = {
  key: 0,
  class: "request-container-invite body error"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("There was an error processing your request")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Back to Home ")
const _hoisted_5 = {
  key: 1,
  class: "request-container-invite loader-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_router_link, {
            class: "borderless toHome",
            to: "/"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1 /* STABLE */
          }),
          _createElementVNode("button", {
            class: "borderless startOver",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.emit('restart')))
          }, "Restart")
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode($setup["Loader"])
        ]))
  ]))
}